import React, { useEffect, useRef } from "react";

const PDFMicrotext = ({
  pdfSrc,
  outerCellColor = "rgba(0, 0, 0, 0.05)",
  innerCellFontSize = 12,
  onReady,
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!pdfSrc) return;

    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = () => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(img, 0, 0);

      // Set font and measure
      ctx.font = `${innerCellFontSize}px Arial`;
      ctx.textBaseline = "top";

      const sampleText = "00000";
      const textMetrics = ctx.measureText(sampleText);
      const cellWidth = textMetrics.width + 8; // padding
      const cellHeight = innerCellFontSize + 6;

      const cols = Math.floor(canvas.width / cellWidth);
      const rows = Math.floor(canvas.height / cellHeight);

      let counter = 1;

      ctx.fillStyle = outerCellColor;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#CCC"; // Light grey microtext
      ctx.font = `${innerCellFontSize}px 'Courier New', monospace`;
      ctx.textBaseline = "top";

      let x = 0;
      let y = 0;

      const numberWidth = ctx.measureText("00000").width + 2; // 5-digit number with slight spacing
      const lineHeight = innerCellFontSize + 2;

      while (y + lineHeight < canvas.height) {
        const paddedNumber = String(counter).padStart(5, "0");
        ctx.fillText(paddedNumber, x, y);

        x += numberWidth;
        if (x + numberWidth >= canvas.width) {
          x = 0;
          y += lineHeight;
        }

        counter++;
      }

      if (onReady) {
        onReady(canvas);
      }
    };

    img.src = pdfSrc;
  }, [pdfSrc, outerCellColor, innerCellFontSize, onReady]);

  return <canvas ref={canvasRef} style={{ width: "100%", display: "block" }} />;
};

export default PDFMicrotext;
